import { useEffect, useState } from 'react'
import confetti from 'canvas-confetti'

/**
 * Use confetti animation
 * `showConfetti` - Whether to show confetti (default: false)
 */
const useConfetti = (showConfetti = true) => {
  const [hasFiredConfetti, setHasFiredConfetti] = useState(false)

  // Set up our confetti animation
  const count = 200
  const defaults = {
    origin: { y: 0.5 }
  }

  const fire = (particleRatio, opts) => {
    // Create our confetti
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
      })
    )
  }

  const handleFireConfetti = () => {
    // Return if we've already fired the confetti or if we're not supposed to
    if (hasFiredConfetti || !showConfetti) return

    // Fire the confetti animation
    fire(0.25, {
      spread: 26,
      startVelocity: 55
    })
    fire(0.2, {
      spread: 60
    })
    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    })
    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    })
    fire(0.1, {
      spread: 120,
      startVelocity: 45
    })

    // Set the confetti flag to true so we don't fire it again
    setHasFiredConfetti(true)
  }

  useEffect(() => {
    // Return if we've already fired the confetti or if we're not supposed to
    if (hasFiredConfetti || !showConfetti) return

    // Fire the confetti animation
    handleFireConfetti()

    // Update the confetti flag
    setHasFiredConfetti(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showConfetti, hasFiredConfetti])

  return null
}

export default useConfetti
